<div class="mon-dialog-header">
  <h3 class="pt-6 mt-3 inline-block">
    <span class="inline-block" translate>
      Please wait - exporting audit log &nbsp;
    </span>
    <span class="fas fa-spinner fa-spin fa-lg"></span>
  </h3>
</div>
<div class="mon-dialog-body auto-scroll">
  <div class="row pb-3">
    <div class="col-48 pt-3 px-6">
      <p class="text-bold">
        {{'Getting [[logs]] out of [[total]] logs' | translate:'':{ logs: logs, total: total } }}
      </p>
    </div>
  </div>
</div>
<div class="mon-dialog-footer text-right">
  <button class="btn btn-border-radius btn-secondary"
          data-test="cancel-button"
          (click)="cancel()"
          translate>
    Cancel
  </button>
</div>
